import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPEnergyConsumptionPostDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPPreventiveWork/STPPreventiveEnergyConsumptionSlice';
import moment from 'moment'
import STPPowerFailureDataPopup from './STPPreventiveEnergyConsumptionPowerFailurePopup';

export default function STPEnergyConsumptionDataPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, handleIsPost, apiFlag, rowData,EnergyStatus } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();
    const [IsClear, setIsClear] = useState(false)

    const [PreventiveWaterTextField, setPreventiveWaterTextField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        energyMPCNo: Flag === 'Update' ? rowData.energyMPCNo : '',
        todayReading: Flag === 'Update' ? rowData.todayReading : '',
        powerOffTime: Flag === 'Update' ? rowData.powerOffTime : '',
        powerOnTime: Flag === 'Update' ? rowData.powerOnTime : '',
        dieselConsumtion: Flag === 'Update' ? rowData.dieselConsumtion : '',
    })

    const handlePreventiveWaterTextFieldTextField = (e) => {
        setPreventiveWaterTextField({ ...PreventiveWaterTextField, [e.target.name]: e.target.value })
    }

    const handleClear = () => {
        setIsClear(!IsClear)
        setPreventiveWaterTextField({
            readingDate: '',
            energyMPCNo: '',
            todayReading: '',
        })
    }

    const handlePost = () => {
        const data = {
            T_STP_EnergyConsumptionID: Flag === 'Update' ? rowData.t_stP_EnergyConsumptionID : '0',
            TodayReading: PreventiveWaterTextField.todayReading ? PreventiveWaterTextField.todayReading : '0',
            DieselConsumtion: PreventiveWaterTextField.dieselConsumtion ? PreventiveWaterTextField.dieselConsumtion : '0',
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPEnergyConsumptionPostDataAPI({ data }))
    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Energy Consumption</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            {
                                EnergyStatus.ID === 18 ?
                                    <>
                                    <STPPowerFailureDataPopup
                                    PreventiveWaterTextField={PreventiveWaterTextField}
                                    setPreventiveWaterTextField={setPreventiveWaterTextField}
                                    handlePreventiveWaterTextFieldTextField={handlePreventiveWaterTextFieldTextField}
                                    />
                                    </>
                                    :
                                    <div className="row details-row">
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Reading Date</b></label>
                                                <input type="date"
                                                    className="form-control"
                                                    id="readingDate"
                                                    name='readingDate'
                                                    disabled
                                                    value={PreventiveWaterTextField.readingDate}
                                                    onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 ">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Energy Number</b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="energyMPCNo"
                                                    name='energyMPCNo'
                                                    disabled
                                                    value={PreventiveWaterTextField.energyMPCNo}
                                                    onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}

                                                />

                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Today’s Reading</b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="todayReading"
                                                    name='todayReading'
                                                    value={PreventiveWaterTextField.todayReading}
                                                    onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}

                                                />

                                            </div>
                                        </div>
                                    </div>

                            }


                            <div className="col-12 col-lg-12 pt-lg-4 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost(), handleClear())}
                                        disabled={
                                            PreventiveWaterTextField.readingDate == '' || PreventiveWaterTextField.energyMPCNo == '' ||
                                            PreventiveWaterTextField.todayReading == ''
                                        }
                                  
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}